import * as React from 'react';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';
import IconRow from '../../layout/IconRow';
import BulletedMsg from '../../layout/BulletedMsg';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import { onMobileDevice } from '../../globalStyle/mediaQueries';
import { Requirement } from '../models';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import LocalDiv from '../../localization/LocalDiv';
import { FLEX_COLUMN } from '../../layout/flexBox';


const styles = {
  title:        css`
    margin: 0 0 20px;
    text-align: start;
    color: ${COLORS.DARK_GREY};
    ${onMobileDevice} {
      border-bottom: 1px solid ${COLORS.LIGHT_GREY};
    }
  `,
  label:        css`
    margin-top: 5px;
    margin-bottom: 20px;
    color: ${COLORS.DARK_GREY};
  `,
  completed:    css`
    color: ${COLORS.BLUE};
  `,
  notCompleted: css`
    color: ${COLORS.DISABLED};
  `,
};


type Props = {
  minimumsRequired: boolean;
  requirements: Requirement[] | undefined;
  className?: string;
};


/**
 * RequirementSummary: a component that renders the list of project requirements, just wrapping down and down. If you
 * want to limit the number rendered, then you'll have to limit the props you give this thing. Each requirement is a
 * people row with a label row + label underneath. Requirements with more than 7 people render with a `+n` where n is
 * the remainder.
 *
 * You'll see this mostly on the Dashboard.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RequirementSummary: React.FC<Props> = props => (
  <LocalDiv css={FLEX_COLUMN} className={props.className}>
    <h4 css={styles.title}><Msg str={props.minimumsRequired ? Str.RequiredMinimums : Str.RecommendedMinimums} /></h4>
    {
      props.requirements?.map(
        requirement => {
          const isCompleted = requirement.completedCount >= requirement.minimumRequired;

          return (
            <div key={requirement.fullName} title={`${requirement.completedCount}/${requirement.minimumRequired}`}>
              <IconRow
                iconMax={7}
                numberOfIcons={Math.max(1, requirement.completedCount, requirement.minimumRequired)}
                numberOfActive={isCompleted ? 0 : requirement.completedCount}
                css={isCompleted ? styles.completed : ''}
              />
              <BulletedMsg
                icon={isCompleted ? faCheckCircle : faCircle}
                msg={`${requirement.minimumRequired} ${requirement.fullName}`}
                css={[styles.label, isCompleted ? styles.completed : '']}
                iconStyle={isCompleted ? styles.completed : styles.notCompleted}
              />
            </div>
          );
        },
      )
    }
  </LocalDiv>
);

export default RequirementSummary;
